const setSelectedSupervisorWallboard = (state, wallboard) => {
  state.selectedSupervisorWallboard = structuredClone(wallboard);
};

const setSupervisedAgents = (state, supervisedAgents) => {
  state.supervisedAgents = structuredClone(supervisedAgents);
};

const setSupervisedInteractions = (state, supervisedInteractions) => {
  state.supervisedInteractions = structuredClone(supervisedInteractions);
};

export default {
  setSelectedSupervisorWallboard,
  setSupervisedAgents,
  setSupervisedInteractions
};
